export default {"src":"/_next/static/media/iconLock.6014189f.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};